import { createContext, useContext, useEffect, useMemo, useState } from "react";
import type { ReactNode } from "react";
import { t } from "../i18n/t";

interface AttributionValue {
  text: string;
  setText: (text: string | null) => void;
}

const AttributionContext = createContext<AttributionValue | null>(null);

/** Holds the licence attribution shown in the footer (the API's `attribution` when known). */
export function AttributionProvider({ children }: { children: ReactNode }) {
  const [text, setText] = useState<string | null>(null);
  const value = useMemo(() => ({ text: text ?? t("footer.attributionDefault"), setText }), [text]);
  return <AttributionContext.Provider value={value}>{children}</AttributionContext.Provider>;
}

export function useAttributionText(): string {
  return useContext(AttributionContext)?.text ?? t("footer.attributionDefault");
}

/** Publish the attribution string from an API response to the footer while mounted. */
export function useAttribution(text: string | null | undefined): void {
  const setText = useContext(AttributionContext)?.setText;
  useEffect(() => {
    if (!setText || !text) return;
    setText(text);
    return () => setText(null);
  }, [setText, text]);
}
